module.exports = __webpack_public_path__ + "static/media/class5.d5ac81df.jpg";